module.exports = __webpack_public_path__ + "assets/img/2322-pw.svg";